import React, { Component } from 'react'

class SearchProduct extends Component {
    render() {
        return (
            <div>
                {this.props.items.length ? (
                    <table className="display_table">
                        <thead>
                            <tr className="table-header">
                                <th></th>
                                <th>Title</th>
                                <th>Sku</th>
                                <th>Active</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.items.map((item, i) =>
                                <tr className="clickable" key={i} onClick={() => this.props.history.push(this.props.basePath + '/' + item.permalink)}>
                                    <td className="record-number">{i + this.props.startPosition + 1}</td>
                                    <td data-id="Title">{item.title}</td>
                                    <td data-id="Sku">{item.sku}</td>
                                    <td data-id="Active">{item.active ? 'Yes' : 'No'}</td>
                                    <td className="edit-cell"><div className="edit_btn">View</div></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                ) : (
                    <div>No Results</div>
                )}
            </div>
        )
    }
}

SearchProduct.defaultProps = {
    items: [],
    startPosition: 0,
    clickHandle: null
}

export default SearchProduct



// WEBPACK FOOTER //
// ./src/components/search/SearchProduct.js